define(function(require, exports, module){

	
	var options = {

		required: new RegExp('^.{1,99999999}$'),

		number: new RegExp('^[0-9]+$'),
		
		zFloat: new RegExp('^\\d+(\\.\\d+)?$'),

		email: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/i,

		date: /^(\d{4})-(\d{2})-(\d{2})$/,

		cellphone: /^\d{1,50}$/,

		mobilephohe: /^0?1[2|3|4|5|6|7|8|9][0-9]\d{8}$/,

		//验证密码
		password: /^\S{6,24}$/,

		//验证金额
		money: /^(?!0+$)(?!0*\.0*$)\d{1,8}(\.\d{1,2})?$/,

		captcha: /^[0-9a-z]{1,10}$/i,

		qq: /^[1-9]\d{3,20}$/,

		//比较两个密码是否相同
		comparePass: function(newPassword, repeatPassword){
			return newPassword==repeatPassword;
		},

		numberMin: function(str, min){
			return str > min;
		},

		numberMax: function(str, max){
			return str < max;
		},

		lengthMax: function(str, max){
			return str.length < max;
		},
		lengthMaxEqual: function(str, max){
			return str.length <= max;
		},
		lengthMin: function(str, min){
			return str.length > min;
		},
		lengthMinEqual: function(str, min){
			return str.length >= min;
		},
		length: function(str, val){
			return str.length === val;
		},
		notZero: function(str){
			return str !== '0';
		},
		notEqual: function(str, val){
			return str !== val;
		}

	};
	
	function _valid(str, config){
		for (var name in config) {
			// 当验证的标准是一个方法
			if (typeof(options[name]) === 'function') {

				if (!options[name](str, config[name].value)) {
					return config[name].error;
				}
			} else {
				// 当验证的标准是一个字符串
				if (typeof(options[name]) === 'object') {
					if (!options[name].test(str)) {
						return config[name].error;
					}
				}
			}
		}
		return true;
	}

	return {
		/*
			@param:data 需要验证的数据源
			@param:config 验证配置
		*/
		valid: function(data, configs){
			var res = true;
			if (typeof(data) === 'string') {
				res = _valid(data, configs);
				return res;
			} else {
				for (var name in data) {
					res = _valid(data[name], configs[name]);
					if (res !== true) {
						break;
						return res;
					}
				}
			}
			return res;
		}
	}
});


// WEBPACK FOOTER //
// ./modules/validate/0.0.0/validate.js